// @flow weak

import { isBefore } from 'date-fns';
import * as R from 'ramda';

import { parseBool } from '~/helpers';

type TokenPayload = {
  ace_elev_exp?: number,
  exp?: number,
};

export const isDepositUser = (token: string): boolean => {
  const payload = getTokenPayload(token) || {};

  const isDepo = R.pipe(
    R.prop('ace_depo'),
    parseBool,
  )(payload);

  return isDepo;
};

export const isMerchant = (token: string): boolean => {
  const payload = getTokenPayload(token) || {};

  const role = R.pipe(R.prop('ace_role'))(payload);

  return role === 'm';
};

export const getUserId = (token: string): string => {
  const payload = getTokenPayload(token) || {};

  const userId = R.either(R.prop('sub'), R.prop('id'))(payload);

  return userId;
};

export const isTokenExpired = (
  token: string,
  checkElevation: boolean,
): boolean => {
  const expirationDate: Date = getExpirationDate(token, checkElevation);

  return isBefore(expirationDate, new Date());
};

export const isTokenElevated = (token: string): boolean => {
  const payload: TokenPayload = getTokenPayload(token) || {};

  return !!payload.ace_elev_exp;
};

export const getExpirationDate = (
  token: string,
  checkElevation: boolean,
): Date => {
  const payload: TokenPayload = getTokenPayload(token) || {};
  const date = new Date(0);

  const exp = R.cond([
    [() => !!checkElevation, R.prop('ace_elev_exp')],
    [R.T, R.prop('exp')],
  ])(payload);

  if (exp) {
    date.setUTCSeconds(+exp);
  }

  return date;
};

export const getTokenPayload = (token: string = ''): ?TokenPayload => {
  if (token && token.split('.').length === 3) {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      return JSON.parse(
        decodeURIComponent(encodeURIComponent(window.atob(base64))),
      );
    } catch (e) {
      return undefined;
    }
  }
};
